// FAC-23949: đọc URL ship label của thùng FBA từ label_ship_details (cấu trúc giống labelDetails của barcode -> .url), fallback label_url.
// Dùng cho màn danh sách thùng + chi tiết lô ship (response có label_ship_details).
// LƯU Ý: màn Dán Label FBA (API label-info) trả field khác là `ship_label` -> KHÔNG dùng helper này.
const getBoxShipLabelUrl = (box) =>
    (box && ((box.label_ship_details && box.label_ship_details.url) || box.label_url)) || ''

export default getBoxShipLabelUrl
